import { Component, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpeedDialsService } from '../services';
import { ListTenantSpeedDialsDto } from '../models';
import { SubSink } from 'subsink';
import { DiallerService } from '@app/dialler/services';

@Component({
  selector: 'app-speeddial',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Speed Dials</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.close('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <table>
        <tbody>
          <tr>
            <td colspan="2">
              <input
                #speeddialsearchtext
                (keyup)="this.requeryspeeddial(speeddialsearchtext.value)"
                placeholder="Filter..."
              />
            </td>
          </tr>
          <ng-container *ngFor="let speeddial of speeddials$ | async">
            <tr *ngIf="speeddial.active">
              <td>
                <input
                  type="radio"
                  name="radiogroup"
                  value="{{ speeddial.number }}"
                  (change)="this.selectSpeeddial(speeddial)"
                  [checked]="this.selectnumber === speeddial.number"
                />
              </td>
              <td
                style="padding-left: 10px;cursor: pointer;"
                (click)="this.selectSpeeddial(speeddial)"
              >
                {{ speeddial.name }}
              </td>
              <td
                style="padding-left: 10px;cursor: pointer;"
                (click)="this.selectSpeeddial(speeddial)"
              >
                {{ speeddial.number }}
              </td>
            </tr>
          </ng-container>
          <tr>
            <td colspan="2" style="padding-top: 10px;">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="
                  this.dialSelectedSpeeddial(); activeModal.close('Close click')
                "
              >
                Call Speed Dial
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpeeddialComponent implements OnDestroy {
  private stopRecording: boolean = false;
  private subs = new SubSink();
  selectnumber: string = '';
  speeddials$ = this.speedDialsSvc.speeddials$;

  constructor(
    private speedDialsSvc: SpeedDialsService,
    public activeModal: NgbActiveModal,
    private diallerSvc: DiallerService
  ) {}

  dialSelectedSpeeddial() {
    this.diallerSvc.xferStopRecording = this.stopRecording;
    this.diallerSvc.callManual(this.selectnumber, '', 30);
  }

  ngOnDestroy(): void {
    this.stopRecording = false;
    this.subs.unsubscribe();
  }

  requeryspeeddial(searchvalue: string) {
    this.speedDialsSvc.requerySpeedDials(searchvalue);
    this.speeddials$ = this.speedDialsSvc.speeddials$;
  }

  selectSpeeddial(speeddial: ListTenantSpeedDialsDto) {
    this.stopRecording = speeddial.xferStopRecording;
    this.selectnumber = speeddial.number;
  }
}
